<template>
  <SGPFormBotaoComponent
    fab
    text
    small
    color="primary"
    class="botao-voltar"
    @click="voltar"
  >
    <SGPIconComponent icon="mdi-arrow-left" />
  </SGPFormBotaoComponent>
</template>

<script>
export default {
  name: 'SGPBotaoVoltarComponent',

  methods: {
    voltar () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.botao-voltar {
  min-width: 36px !important;
  width: 36px;
  height: 36px;
}
</style>
